import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

import { BulkEditDataAcquisitionModal } from "@components/organisms/bulk-edit-data-acquisition-type-modal/bulk-edit-data-acquisition-type-modal";

export const BulkEditDataAcquisition = () => {
  const showBulkEditDataAcquisitionModal = useSelector(
    (state: RootState) => state.yourSlice.showBulkEditDataAcquisitionTypeModal,
  );

  return (
    <>{showBulkEditDataAcquisitionModal && <BulkEditDataAcquisitionModal />}</>
  );
};
